import * as api from '../../../../../api/masters/users/users/userApi';
import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  ADD_USER_SUCCESS,
  UPDATE_USER_SUCCESS,
  DELETE_USER_SUCCESS,
  SET_EDITING_USER,
  CLEAR_EDITING_USER
} from '../../../../types/masters/users/user/userTypes';

export const fetchUsers = () => async (dispatch) => {
  dispatch({ type: FETCH_USERS_REQUEST });
  try {
    const users = await api.fetchUsers();
    dispatch({ type: FETCH_USERS_SUCCESS, payload: users });
  } catch (error) {
    dispatch({ type: FETCH_USERS_FAILURE, error: error.message });
  }
};

export const addUser = (user) => async (dispatch) => {
  try {
    const newUser = await api.addUser(user);
    dispatch({ type: ADD_USER_SUCCESS, payload: newUser });
    return null;
  } catch (error) {
    return error.message;
  }
};

export const updateUser = ({ id, user }) => async (dispatch) => {
  try {
    const updated = await api.updateUser(id, user);
    dispatch({ type: UPDATE_USER_SUCCESS, payload: updated });
    return null;
  } catch (error) {
    return error.message;
  }
};

export const deleteUser = (id) => async (dispatch) => {
  await api.deleteUser(id);
  dispatch({ type: DELETE_USER_SUCCESS, payload: id });
};

export const setEditingUser = (user) => ({ type: SET_EDITING_USER, payload: user });
export const clearEditingUser = () => ({ type: CLEAR_EDITING_USER });
